<template>
  <div>
    <b-modal id='connect-to-wallet-id' class='' ref='connect-to-wallet-id' hide-header hide-footer centered>
        <b-container fluid>
          <b-row>
            <b-col cols=12 class='header'>
              <h5>Connect to wallet</h5>
            </b-col>
            <!-- billeteras -->
            <b-col class='body mt-4' cols=12>
              <b-row>
                <b-col cols=12 class='text-center'>
                  <p>Choosing to connect indicates that you have acceptedTerms of ServicePrivacy Policy</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols=12>
                  <div class='wraper'>
                    <img class='m-2' src="../../assets/wallet/logo-tronlink.png" alt="Kitten">
                    <img class='m-2' src="../../assets/wallet/logo-klever.png" alt="Kitten">
                    <img class='m-2' src="../../assets/wallet/logo-token-pocket.png" alt="Kitten">
                  </div>
                </b-col>
              </b-row>
              <!-- formulario login-->
              <b-row>
                <b-col cols=12 class='mt-4'>
                  <div v-if="isErrors" class='pt-4 text-center'>
                    <p class="text-danger" >{{this.message}}</p>
                  </div>
                  <b-form v-else @submit.stop.prevent="onSubmit">
                    <h6>Address</h6>
                    <b-form-group  id="input-group-wallet"  label-for="input_wallet">
                      <b-form-input
                        id="input_wallet"
                        name="input_wallet"
                        placeholder=""
                        autocomplete="off"
                        v-model="getAddress"
                        :disabled = 'true'
                      ></b-form-input>
                      <b-form-invalid-feedback
                        :state="this.message === ''"
                        class="pl-2 text-danger"
                        id="input_wallet_live_feedback"
                      >
                      {{this.message}}
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <div class="form-group text-center my-3 ">
                      <b-button class="" type="submit" variant="primary">Connect</b-button>
                    </div>
                  </b-form>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  props: ['openModal'],
  data () {
    return {
      message: '',
      pluginWallet: false,
      form: {
        wallet: ''
      },
      errorMessages: {
        required: 'Este campo es requerido.'
      }
    }
  },
  created () {},
  mounted () {},
  computed: {
    ...mapGetters({
      getAddress: 'getAddress',
      getOptionsAuthWallet: 'auth/getOptionsAuthWallet',
      walletIsInstalled: 'walletIsInstalled'
    }),
    isErrors () {
      if (!this.walletIsInstalled) {
        this.setMessage('Error: No TRON compatible wallet detected.') // ES: No se ha detectado una billetera compatible con TRON
        return true
      } else
      if (this.getAddress === '') {
        this.setMessage('Error: First log in to the wallet.') // ES: Primero inicie sesión en la billetera
        return true
      }
      this.setMessage('')
      return false
    },
    OpenModal: {
      get () { return this.openModal },
      set (val) { this.$emit('setOpenModal', val) }
    },
    isLoading () { return this.$store.getters.isLoading }
  },
  watch: {
    openModal: {
      deep: true,
      handler: function (nuevoValor, valorAnterior) {
        if (this.OpenModal) {
          this.OpenModal = false
          this.$refs['connect-to-wallet-id'].show()
        }
      }
    },
    isLoading (_new, old) {
      if (_new) {
        this.OpenModal = false
        this.$refs['connect-to-wallet-id'].hide()
      }
    }
  },
  methods: {
    async onSubmit () {
      console.log('onSubmit')
      localStorage.LOGGED_IN = this.getOptionsAuthWallet.LOGGED_IN
      localStorage.ADDRESS = this.getAddress
      await this.$store.commit(
        'auth/setStatusAuthWallet',
        this.getOptionsAuthWallet.LOGGING_IN
      )
      this.$store.commit(
        'auth/setStatusAuthWallet',
        this.getOptionsAuthWallet.LOGGED_IN
      )
      this.$refs['connect-to-wallet-id'].hide()
    },
    setMessage (str) {
      this.message = str
    }
  }
}
</script>
<style></style>
